import React from "react"
import {Field, withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";
import BaseComponent from "../../../base-component";
import {Collapse} from "reactstrap";
import CountrySelect from "../../../country-select";
import EmployeeSelect from "../../../../../../idoa/app/components/shared/employee-select";
import PhoneInput from "./phone-input";
import Cleave from 'cleave.js/src/Cleave.react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Page2 extends BaseComponent {

    constructor(params) {
        super(params);
    }

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, isComplete } = this.props;
        const formatPostcode = ['CZE', 'SVK'].includes(values.data.address_country);
        const formatContactPostcode = ['CZE', 'SVK'].includes(values.data.contact_address_country);

        return (
            <form onSubmit={handleSubmit}>
                <h3><FormattedMessage id='app.personal_forms.page_2.title'/></h3>
                <p><FormattedMessage id='app.personal_forms.page_2.info'/></p>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.address'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                        </div>

                        <div className='form-group'>
                            <label className='small'><FormattedMessage id='app.personal_forms.attribute.address_street'/></label>
                            <input disabled={isComplete} type="text" className='form-control' id='data.address_street' value={values.data.address_street} onChange={handleChange}/>
                            <div className='shift small text-muted'><FormattedMessage id={'app.personal_forms.attribute.address_street.info'}/></div>
                            { displayErrors(errors, 'data.address_street') }
                        </div>
                        <div className='row'>
                            <div className='col-6'>
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.address_land_registry_number'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                    <input disabled={isComplete} type="text" className='form-control' id='data.address_land_registry_number' value={values.data.address_land_registry_number} onChange={handleChange}/>
                                    { displayErrors(errors, 'data.address_land_registry_number') }
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.address_house_number'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                    <input disabled={isComplete} type="text" className='form-control' id='data.address_house_number' value={values.data.address_house_number} onChange={handleChange}/>
                                    { displayErrors(errors, 'data.address_house_number') }
                                </div>
                            </div>
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.address_city'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.address_city' value={values.data.address_city} onChange={handleChange}/>
                            { displayErrors(errors, 'data.address_city') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.address_country'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                            <CountrySelect disabled={isComplete} value={values.data.address_country} onChange={(value) => { setFieldValue('data.address_country', value); setFieldValue('data.address_postcode', '') }}/>
                            { displayErrors(errors, 'data.address_country') }
                        </div>
                        {
                            formatPostcode &&
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.address_postcode'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                <Cleave options={{
                                            blocks: [3, 2],
                                            numericOnly: true
                                        }}
                                        value={values.data.address_postcode}
                                        disabled={isComplete}
                                        className={'form-control'}
                                        onChange={(event) => { setFieldValue('data.address_postcode', event.target.value) }} />
                                { displayErrors(errors, 'data.address_postcode') }
                            </div>
                        }
                        {
                            !formatPostcode &&
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.address_postcode'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.address_postcode' value={values.data.address_postcode} onChange={handleChange}/>
                                { displayErrors(errors, 'data.address_postcode') }
                            </div>
                        }
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <div className="custom-control custom-switch pb-2">
                                <input disabled={isComplete} type="checkbox" className="custom-control-input" id='data.contact_address_different' checked={values.data.contact_address_different} onChange={handleChange}/><label className="custom-control-label" htmlFor="data.contact_address_different"><FormattedMessage id='app.personal_forms.attribute.contact_address_different'/></label>
                            </div>
                        </div>
                        <Collapse isOpen={values.data.contact_address_different !== '' && values.data.contact_address_different}>
                            <div className='form-group'>
                                <label className='small'><FormattedMessage id='app.personal_forms.attribute.contact_address_street'/></label>
                                <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_street' value={values.data.contact_address_street} onChange={handleChange}/>
                                <div className='shift small text-muted'><FormattedMessage id={'app.personal_forms.attribute.contact_address_street.info'}/></div>
                                { displayErrors(errors, 'data.contact_address_street') }
                            </div>
                            <div className='row'>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <FormattedMessage id='app.personal_forms.attribute.contact_address_land_registry_number'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                        <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_land_registry_number' value={values.data.contact_address_land_registry_number} onChange={handleChange}/>
                                        { displayErrors(errors, 'data.contact_address_land_registry_number') }
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <FormattedMessage id='app.personal_forms.attribute.contact_address_house_number'>{(txt) => (<label className='small'>{txt}</label>)}</FormattedMessage>
                                        <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_house_number' value={values.data.contact_address_house_number} onChange={handleChange}/>
                                        { displayErrors(errors, 'data.contact_address_house_number') }
                                    </div>
                                </div>
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.contact_address_city'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_city' value={values.data.contact_address_city} onChange={handleChange}/>
                                { displayErrors(errors, 'data.contact_address_city') }
                            </div>
                            <div className='form-group'>
                                <FormattedMessage id='app.personal_forms.attribute.contact_address_country'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                <CountrySelect disabled={isComplete} value={values.data.contact_address_country} onChange={(value) => { setFieldValue('data.contact_address_country', value); setFieldValue('data.contact_address_postcode', '') }}/>
                                { displayErrors(errors, 'data.contact_address_country') }
                            </div>
                            {
                                formatContactPostcode &&
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.contact_address_postcode'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                    <Cleave options={{
                                        blocks: [3, 2],
                                        numericOnly: true
                                    }}
                                            value={values.data.contact_address_postcode}
                                            disabled={isComplete}
                                            className={'form-control'}
                                            onChange={(event) => { setFieldValue('data.contact_address_postcode', event.target.value) }} />
                                    { displayErrors(errors, 'data.contact_address_postcode') }
                                </div>
                            }
                            {
                                !formatContactPostcode &&
                                <div className='form-group'>
                                    <FormattedMessage id='app.personal_forms.attribute.contact_address_postcode'>{(txt) => (<label className='required-field small'>{txt}</label>)}</FormattedMessage>
                                    <input disabled={isComplete} type="text" className='form-control' id='data.contact_address_postcode' value={values.data.contact_address_postcode} onChange={handleChange}/>
                                    { displayErrors(errors, 'data.contact_address_postcode') }
                                </div>
                            }
                        </Collapse>
                    </div>
                </div>

                <hr/>

                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.phone'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <div className='input-group'>
                                <div className="input-group-prepend">
                                    <Field name='data.phone_country' disabled={isComplete} component={PhoneInput}/>
                                </div>
                                <Cleave options={{
                                    numericOnly: true
                                }}
                                        value={values.data.phone}
                                        disabled={isComplete}
                                        className={'form-control'}
                                        onChange={(event) => { setFieldValue('data.phone', event.target.rawValue) }} />
                            </div>
                            { displayErrors(errors, 'data.phone_country') }
                            { displayErrors(errors, 'data.phone') }
                        </div>
                    </div>
                </div>

                <div className='clearfix'>
                    <hr/>
                    <button type='button' className='btn btn-secondary' onClick={this.props.previous}>{intl.formatMessage({id: 'app.personal_forms.buttons.previous_step'})}</button>
                    { !isComplete && <button type='submit' className='btn btn-primary float-right' disabled={isSubmitting}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}{this.spinner(isSubmitting)}</button> }
                    { isComplete && <button type='button' className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.props.next}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}</button> }
                </div>
            </form>
        )
    }

}

export default injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { data: { ...props.resource.data, page: 3 } };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(Page2));
